import { resolve } from 'styled-jsx/css';

export const getBoxStyle = (squareBorder?: boolean, padding?: string): { className: string; styles: string } =>
  resolve`
  .extended-footer-box {
    flex: 1;
    min-height: 258px;
    flex-direction: column;
    display: flex;
    align-items: center;
  }

  .extended-footer-box {
    padding: ${padding || '0 46px'};
    ${squareBorder ? 'border: 4px solid #eeeef0;' : ''}
  }

  @media (max-width: 1023px) {
    .extended-footer-box {
      justify-content: center;
      padding: 0 66px 0;
    }

    .extended-footer-box:last-of-type {
      padding: 55px 66px 35px;
    }

    .extended-footer-box {
      ${!squareBorder ? 'border-top: 4px solid #eeeef0;' : ''}
    }
  }

  @media (min-width: 1024px) {
    .extended-footer-box:not(:last-of-type) {
      ${squareBorder ? 'border-right: 0;' : ''}
      ${!squareBorder ? 'border-right: 4px solid #eeeef0;' : ''}
    }
  }
`;

export const getTextStyle = (): { className: string; styles: string } => resolve`
  .extended-footer-text {
    color: #000000;
    font-family: Avenir;
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    text-align: center;
  }

  .bottom {
    margin-bottom: 33px;
    margin-top: 20px;
  }
`;

export const getTitleStyle = (color?: string): { className: string; styles: string } => resolve`
  .extended-footer-title {
    text-align: center;
    text-transform: uppercase;
    font-family: Avenir;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 20px;
    margin-top: 34px;
    margin-bottom: 20px;
  }

  .extended-footer-title {
    color: ${color || '#000000'};
  }

  @media (max-width: 1023px) {
    .extended-footer-title {
      margin-top: 0px;
    }
  }
`;
